const getMinutesRemaining = (timeInSeconds: number) => Math.floor(timeInSeconds / 60);
const getSecondsRemaining = (timeInSeconds: number) => timeInSeconds % 60;

function format(timeLeft: number, intervalSeconds: number) {
  const minutes = getMinutesRemaining(timeLeft);
  const seconds = getSecondsRemaining(timeLeft);
  const secondsRemainingInInterval = Math.floor(seconds / intervalSeconds) * intervalSeconds;

  return {
    minutesRemaining: minutes,
    secondsRemaining: secondsRemainingInInterval,
  };
}

export default format;
